import React, { useState, useEffect } from "react";
import { Tabs, Tab, styled } from "@mui/material";
import { UserTierType } from "@/constants/enums/user-tier-type.enum";
import TermSheetTableT1T2 from "./T1&T2/TermSheetTable-T1-T2";
import TermSheetTableT4 from "./T4/TermSheetTable-T4";
import ReceivedTermSheetTable from "./T3/ReceivedTermSheetTable";
import CreatedTermSheetTable from "./T3/CreatedTermSheetTable";

const StyledTabs = styled(Tabs)({
  minHeight: "unset",
  "& .MuiTabs-indicator": {
    display: "none",
  },
});

const StyledTab = styled(Tab)({
  minHeight: "unset",
  padding: "8px 16px",
  textTransform: "none",
  fontSize: "14px",
  fontWeight: 600,
  minWidth: "unset",
});

interface TermSheetDocumentsProps {
  tabId: number;
}

const TermSheetDocuments: React.FC<TermSheetDocumentsProps> = ({ tabId }) => {
  const [userType, setUserType] = useState<UserTierType | null>(null);
  const [activeTab, setActiveTab] = useState(0);

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("user") || "{}");
    const currentUserType = (user.user_type?.id ||
      UserTierType.Tier1) as UserTierType;
    setUserType(currentUserType);
  }, []);

  const handleTabChange = (_: React.SyntheticEvent, newValue: number) => {
    setActiveTab(newValue);
  };

  const renderContent = () => {
    if (!userType) return null;
    switch (userType) {
      case UserTierType.Tier1:
      case UserTierType.Tier2:
        return <TermSheetTableT1T2 tabId={tabId} />;
      case UserTierType.Tier3:
        return (
          <div>
            <div className="tw-px-6 tw-pt-4 tw-bg-white tw-border-b tw-border-[#E9EAEB]">
              <div className="tw-w-fit tw-border tw-border-[#E9EAEB] tw-mt-4">
                <StyledTabs value={activeTab} onChange={handleTabChange}>
                  <StyledTab
                    label="Received Terms Sheet"
                    className={`tw-text-sm tw-font-semibold ${
                      activeTab === 0 ? "active-tab" : "tw-text-[#232323]"
                    } tab-border`}
                  />
                  <StyledTab
                    label="Created Terms Sheet"
                    className={`tw-text-sm tw-font-semibold ${
                      activeTab === 1 ? "active-tab" : "tw-text-[#232323]"
                    } tab-border`}
                  />
                </StyledTabs>
              </div>
            </div>
            <div className="tw-mt-4">
              {activeTab === 0 ? (
                <ReceivedTermSheetTable tabId={tabId} />
              ) : (
                <CreatedTermSheetTable tabId={tabId} />
              )}
            </div>
          </div>
        );
      case UserTierType.Tier4:
        return <TermSheetTableT4 tabId={tabId} />;
      default:
        return null;
    }
  };

  return <div className="tw-w-full">{renderContent()}</div>;
};

export default TermSheetDocuments;
